import { useState, useEffect } from 'react';
import { IDatingProfileModel, ISentMatch } from '../../models/dating.model';
import { datingService } from '../../services/dating.service';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { RootState, LocalStorageService } from '../../configuration';
// import { RootState } from '../../configuration';
export interface IDatingInfo {
  remainingMatchRequests: number;
totalMatchedProfiles: number;
totalSentMatchRequests: number;
}

export interface IFriendDating {
  profileId: string
  nickname: string
  avatar: any
  isOnline: boolean
  lastTime: string
}

export const useDating = ({reloadKey, pageSize=10 }:{reloadKey?: string, pageSize?: number}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [datingProfile, setDatingProfile] = useState<IDatingProfileModel>();
  const [userDatingProfiles, setUserDatingProfiles] = useState<IDatingProfileModel[]>([]);
  const [matchRequests, setMatchRequests] = useState<any[]>([]);
  const [datingInfo, setDatingInfo] = useState<IDatingInfo>({remainingMatchRequests: 0, totalMatchedProfiles: 0, totalSentMatchRequests: 0});
  const [connected, setConnected] = useState<IDatingProfileModel[]>([]);
  const [sendConnected, setSendConnected] = useState<ISentMatch[]>([]);
  const [matchProfile, setMatchProfile] = useState<IDatingProfileModel>({
    profileId: "",
    nickname: "",
    avatar: "",
    interests: [""],
    interestIds: [""],
    coverImage: "",
    city: "",
    additionLocation: "",
    age: 0,
    gender: "",
    cityId: "",
    education: "",
    occupation: "",
    height: 0,
    weight: 0,
    birthDay: "",
    description: "",
    preferredAge: 0,
    preferredGender: "",
    albumUrls: [""],
    address: "",
  });
  const [friendsDating, setFriendsDating] = useState<IFriendDating[]>([]);
  const getDatingProfile = async () => {
    try {
      //
      const data = await datingService.getDatingProfile();
      setDatingProfile(_.get(data, 'data'));
    } catch {
      //
    }
  };

  const getUserDatingProfiles = async () => {
    try {
      setIsLoading(true);
      const data = await datingService.getUserDatingProfiles({});
      setUserDatingProfiles(_.get(data, 'data', []));
    } catch {
      //
    } finally {
      setIsLoading(false);
    }
  };

  const getMatchRequestsByProfileId = async (profileId: string) => {
    try {
      const data = await datingService.getMatchRequestsByProfileId(profileId);
      setMatchRequests(_.get(data, 'data', []));
    } catch {
      //
    }
  };

  const getDatingInfoByProfileId = async (profileId: string) => {
    try {
      const data = await datingService.getDatingInfoByProfileId(profileId);
      setDatingInfo(_.get(data, 'data', []));
    } catch {
      //
    }
  };


  const getConnected = async () => {
    try {
      const data = await datingService.getConnected();
      setConnected(_.get(data, 'data', []));
    } catch {
      //
    }
  };

  const getProfileMatch = async (profileId: string) => {
    try {
      const data = await datingService.getProfileMatch(profileId);
      setMatchProfile(data.data)
    } catch {
      //
    }
  };


  const getSendConnected = async (profileId: string) => {
    try {
      const data = await datingService.getSendConnected(profileId);
      setSendConnected(_.get(data, 'data', []));
    } catch {
      //
    }
  };


  // Hook này chạy trong SignalRProvider (bọc TOÀN app) nên các lời gọi dưới đây
  // bắn ở MỌI trang. Chưa đăng nhập thì chúng trả 401 vô ích — và trước đây còn
  // kéo cả trang công khai (overlay OBS, /reels, /old) về /account/login.
  const hasSession = !!LocalStorageService.getItem('accessToken');

  useEffect(() => {
    if (!hasSession) return;
    getDatingProfile();
  }, [hasSession]);

  useEffect(() => {
    if (!hasSession) return;
    getConnected();
  }, [reloadKey, hasSession])

  useEffect(() => {
   if(datingProfile?.userId) {
     getSendConnected(datingProfile?.profileId);
    }
  }, [datingProfile,reloadKey]);


  const getFriendsDating = async () => {
      try {
        if (!datingProfile?.profileId) return;
    
        const { data, total } = await datingService.getFriendsDating(
          datingProfile.profileId, 
          1, // pageNumber
          pageSize
        );
        
        setFriendsDating(data);
      } catch (error) {
        console.error(error);
      }
     finally {
      //
    }
  };

  useEffect(() => {
    getFriendsDating();
  }, [datingProfile]);
  return {
    isLoading,
    datingProfile,
    getDatingProfile,
    userDatingProfiles,
    getUserDatingProfiles,
    matchRequests,
    getMatchRequestsByProfileId,
    getDatingInfoByProfileId,
    datingInfo,
    connected,
    getProfileMatch,
    matchProfile,
    sendConnected,
    friendsDating,
  };
};
